/* eslint-disable import/prefer-default-export */
import React from "react";
import ListDropdown from "../phase3/ListDropdown";
import getLocationType from "../../../Utils/getLocationType";
import SubmittedDetails from "../../../Core/Components/SubmittedDetails";

export const locationColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Name
      </div>
    ),
    width: "15%",
    dataIndex: "name",
    sorter: (a, b) => a?.name?.localeCompare(b?.name),
    render: (text) => (
      <div>
        <div className="text-xs font-semibold font-aileron leading-4.5 text-black capitalize">
          {text}
        </div>
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Address
      </div>
    ),
    width: "15%",
    dataIndex: "address",
    sorter: (a, b) => a?.address?.localeCompare(b?.address),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Latitude, Longitude
      </div>
    ),
    width: "15%",
    dataIndex: "id",
    sorter: (a, b) => a?.lat?.localeCompare(b?.lat),
    render: (text, record) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {parseFloat(record.lat).toFixed(6)},{" "}
        {parseFloat(record.long).toFixed(6)}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Hub Station
      </div>
    ),
    width: "15%",
    dataIndex: "hubName",
    sorter: (a, b) => a?.hubName?.localeCompare(b?.hubName),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Activity
      </div>
    ),
    width: "15%",
    dataIndex: "type",
    sorter: (a, b) => a.type - b.type,
    render: (text) => <div className="">{getLocationType(text)}</div>,
  },
  {
    title: () => (
      <div className="font-normal font-poppins text-10 text-dark-gray">
        Date of Entry
      </div>
    ),
    width: "15%",
    dataIndex: "submittedAt",
    sorter: (a, b) => a?.submittedAt?.localeCompare(b?.submittedAt),
    render: (text, record) => <SubmittedDetails record={record} />,
  },
  {
    dataIndex: "id",
    width: "5%",
    render: (text, record) => (
      <button
        type="button"
        onClick={(event) => {
          event.stopPropagation();
        }}
        className="invisible group-hover:visible w-full flex items-center justify-center"
      >
        <ListDropdown selectedLocation={record} />
      </button>
    ),
  },
];
